module.exports = __webpack_public_path__ + "static/media/teamicon.0652abde.png";